import { render, staticRenderFns } from "./Sunmi.vue?vue&type=template&id=2469053a&scoped=true"
import script from "./Sunmi.vue?vue&type=script&lang=js"
export * from "./Sunmi.vue?vue&type=script&lang=js"
import style0 from "./Sunmi.vue?vue&type=style&index=0&id=2469053a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2469053a",
  null
  
)

export default component.exports